import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  computed,
  withDefaults,
  onMounted,
  onBeforeUnmount,
} from 'vue';
import type { ComputedRef } from 'vue';
import { TUIVideoStreamType } from '@tencentcloud/tuiroom-engine-js';
import StreamPlay from './StreamPlay/index.vue';
import StreamCover from './StreamCover/index.vue';
import LocalScreenView from './LocalScreenView/index.vue';
import { StreamInfo } from '../../../stores/room';
import { useBasicStore } from '../../../stores/basic';
import '../../../directives/vDblTouch';
import '../../../directives/vTouchScale';

interface Props {
  streamInfo: StreamInfo;
  isEnlarge?: boolean;
  aspectRatio?: string;
  isNeedPlayStream?: boolean;
  observerViewInVisible?: boolean;
  supportTouchScale?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamRegionPC',
  props: {
    streamInfo: null,
    isEnlarge: { type: Boolean, default: false },
    aspectRatio: null,
    isNeedPlayStream: { type: Boolean, default: true },
    observerViewInVisible: { type: Boolean },
    supportTouchScale: { type: Boolean }
  },
  emits: ['room-dblclick'],
  setup(__props: any) {

const props = __props as { streamInfo: StreamInfo, isEnlarge: boolean, aspectRatio?: string, isNeedPlayStream: boolean, observerViewInVisible?: boolean, supportTouchScale?: boolean };




const basicStore = useBasicStore();

const isLocalScreen = computed(
  () =>
    props.streamInfo &&
    props.streamInfo.userId === basicStore.userId &&
    props.streamInfo.streamType === TUIVideoStreamType.kScreenStream
);

const streamRegionContainerRef = ref();
const streamStyle = ref({ width: '', height: '' });

const widthRatio: ComputedRef<number> = computed(() => {
  if (!props.aspectRatio || props.aspectRatio.indexOf(':') < 0) {
    return 0;
  }
  return Number(props.aspectRatio.split(':')[0]);
});
const heightRatio: ComputedRef<number> = computed(() => {
  if (!props.aspectRatio || props.aspectRatio.indexOf(':') < 0) {
    return 0;
  }
  return Number(props.aspectRatio.split(':')[1]);
});

function handleStreamRegionSize() {
  if (!streamRegionContainerRef.value) {
    return;
  }
  const containerWidth = streamRegionContainerRef.value.offsetWidth;
  const containerHeight = streamRegionContainerRef.value.offsetHeight;
  let width = containerWidth;
  let height = containerHeight;
  if (widthRatio.value && heightRatio.value) {
    const scaleWidth = containerWidth / widthRatio.value;
    const scaleHeight = containerHeight / heightRatio.value;
    if (scaleWidth > scaleHeight) {
      width = (containerHeight / heightRatio.value) * widthRatio.value;
      height = containerHeight;
    }
    if (scaleWidth <= scaleHeight) {
      width = containerWidth;
      height = (containerWidth / widthRatio.value) * heightRatio.value;
    }
  }
  streamStyle.value.width = `${width}px`;
  streamStyle.value.height = `${height}px`;
}

const ro = new ResizeObserver(() => {
  handleStreamRegionSize();
});

onMounted(() => {
  ro.observe(streamRegionContainerRef.value as Element);
});

onBeforeUnmount(() => {
  ro.unobserve(streamRegionContainerRef.value as Element);
});

return { __sfc: true,props, basicStore, isLocalScreen, streamRegionContainerRef, streamStyle, widthRatio, heightRatio, handleStreamRegionSize, ro, StreamPlay, StreamCover, LocalScreenView }
}

})